import {Directive} from "@angular/core";

@Directive({
    selector: "[woa-page-footer-control]"
})
export class PageFooterControlDirective {
}



// WEBPACK FOOTER //
// ./src/app/page-layout/page-footer-control.directive.ts